import React from "react";

export const Undo = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M1.3125 3.0625V5.6875H3.9375"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M8.93758 11.4053C9.80341 11.0245 10.5378 10.3969 11.049 9.60111C11.5603 8.80529 11.8256 7.87646 11.812 6.93068C11.7984 5.9849 11.5063 5.06411 10.9724 4.28336C10.4384 3.50261 9.68622 2.89652 8.80977 2.54081C7.93333 2.18511 6.97149 2.09557 6.04445 2.28338C5.1174 2.47119 4.26626 2.92803 3.59736 3.5968L1.79102 5.25006"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export const Redo = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M12.6875 3.0625V5.6875H10.0625"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M5.06242 11.4053C4.19659 11.0245 3.46218 10.3969 2.95096 9.60111C2.43973 8.80529 2.17436 7.87646 2.18799 6.93068C2.20163 5.9849 2.49367 5.06411 3.02763 4.28336C3.56159 3.50261 4.31378 2.89652 5.19023 2.54081C6.06667 2.18511 7.02851 2.09557 7.95555 2.28338C8.8826 2.47119 9.73374 2.92803 10.4026 3.5968L12.209 5.25006"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
